import React from 'react';
import { Layout as AntLayout } from 'antd';
import Sidebar, { TopBar } from '../sidebar/Sidebar';
import { useSidebarController } from '../sidebar/sidebar.controller';
import { layout } from '../../../theme/tokens';

const { Content } = AntLayout;

/** App shell: sidebar, top bar and a centered content column. */
export default function Layout({ children, current }) {
    const shell = useSidebarController(current ?? '');

    return (
        <AntLayout className="min-h-screen !bg-surface-50">
            <Sidebar shell={shell} />
            <AntLayout className="!bg-transparent min-w-0">
                <TopBar shell={shell} />
                <Content className="px-4 md:px-8 pt-4 md:pt-6 pb-12 min-w-0">
                    <div className="mx-auto w-full animate-in" style={{ maxWidth: layout.contentMaxWidth }}>
                        {children}
                    </div>
                </Content>
            </AntLayout>
        </AntLayout>
    );
}
